module.exports = __webpack_public_path__ + "img/img-redtiger.39ac2df0.png";